(function () {
  'use strict';

  function slideScrollLeft(track, slide) {
    var trackRect = track.getBoundingClientRect();
    var slideRect = slide.getBoundingClientRect();
    return slideRect.left - trackRect.left + track.scrollLeft;
  }

  function nearestIndex(track, slides) {
    var nearest = 0;
    var nearestDist = Infinity;
    var left = track.scrollLeft;
    for (var i = 0; i < slides.length; i += 1) {
      var dist = Math.abs(slideScrollLeft(track, slides[i]) - left);
      if (dist < nearestDist) {
        nearestDist = dist;
        nearest = i;
      }
    }
    return nearest;
  }

  function setNavState(prevBtn, nextBtn, index, maxIndex) {
    if (prevBtn) {
      prevBtn.disabled = index <= 0;
      prevBtn.setAttribute('aria-disabled', index <= 0 ? 'true' : 'false');
      prevBtn.classList.toggle('is-disabled', index <= 0);
    }
    if (nextBtn) {
      nextBtn.disabled = index >= maxIndex;
      nextBtn.setAttribute('aria-disabled', index >= maxIndex ? 'true' : 'false');
      nextBtn.classList.toggle('is-disabled', index >= maxIndex);
    }
  }

  function initSlider(root) {
    var track = root.querySelector('[data-acc-ro-gear-track]');
    var slides = Array.prototype.slice.call(
      root.querySelectorAll('[data-acc-ro-gear-slide]')
    );
    var prevBtn = root.querySelector('[data-acc-ro-gear-prev]');
    var nextBtn = root.querySelector('[data-acc-ro-gear-next]');
    var dotsWrap = root.querySelector('[data-acc-ro-gear-dots]');

    if (!track || slides.length === 0) return;

    var index = 0;
    var dots = [];
    var scrolling = false;

    function isMobile() {
      return window.matchMedia('(max-width: 767px)').matches;
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      dots = [];
      for (var i = 0; i < slides.length; i += 1) {
        (function (dotIndex) {
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'ACC_RO_Homepage_19_04_dot';
          button.setAttribute('aria-label', 'Go to product ' + (dotIndex + 1));
          button.addEventListener('click', function () {
            goTo(dotIndex);
          });
          dotsWrap.appendChild(button);
          dots.push(button);
        })(i);
      }
    }

    function updateDots() {
      for (var i = 0; i < dots.length; i += 1) {
        var active = i === index;
        dots[i].classList.toggle('is-active', active);
        dots[i].setAttribute('aria-current', active ? 'true' : 'false');
      }
    }

    function updateUI(fromScroll) {
      if (!isMobile()) {
        setNavState(prevBtn, nextBtn, 0, 0);
        return;
      }

      setNavState(prevBtn, nextBtn, index, slides.length - 1);
      updateDots();

      if (!fromScroll) {
        var target = slides[index];
        if (target) {
          scrolling = true;
          track.scrollTo({
            left: slideScrollLeft(track, target),
            behavior: 'smooth'
          });
          window.setTimeout(function () {
            scrolling = false;
            index = nearestIndex(track, slides);
            setNavState(prevBtn, nextBtn, index, slides.length - 1);
            updateDots();
          }, 350);
        }
      }
    }

    function goTo(nextIndex) {
      if (!isMobile()) return;
      var max = slides.length - 1;
      index = Math.max(0, Math.min(max, nextIndex));
      updateUI(false);
    }

    function syncFromScroll() {
      if (!isMobile() || scrolling) return;
      index = nearestIndex(track, slides);
      setNavState(prevBtn, nextBtn, index, slides.length - 1);
      updateDots();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (event) {
        event.preventDefault();
        goTo(index - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (event) {
        event.preventDefault();
        goTo(index + 1);
      });
    }

    var scrollTimer;
    track.addEventListener(
      'scroll',
      function () {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(syncFromScroll, 60);
      },
      { passive: true }
    );

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        buildDots();
        index = nearestIndex(track, slides);
        updateUI(true);
      }, 150);
    });

    buildDots();
    updateUI(true);
  }

  function initAll() {
    var roots = document.querySelectorAll('.ACC_RO_Homepage_19_04[data-acc-ro-gear]');
    for (var i = 0; i < roots.length; i += 1) {
      initSlider(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
